import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import SolarIcon from 'components/icons/SolarIcon';
import { useCustomersList } from './context/CustomersListProvider';
import CustomersFilter from './CustomersListToolBar/CustomersFilter';

interface CustomersListToolBarProps {
    onCreate: () => void;
}

const CustomersListToolBar = ({ onCreate }: CustomersListToolBarProps) => {
    const { t } = useTranslation(['Clients']);
    const { triggerListReset, triggerListRefresh } = useCustomersList();

    return (
        <div className="mb-3" style={{ minWidth: '100px' }}>
            <div className="page-toolbar-actions">
                <Button
                    className="fs-14 ms-1"
                    size="sm"
                    variant="success"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        onCreate();
                    }}
                >
                    <SolarIcon name="plus" className="fs-14 p-0" />
                    <span className="ms-1">{t('subjects.toolAdd')}</span>
                </Button>

                <ListToolBarActions onReset={triggerListReset} onRefresh={triggerListRefresh} />

                <CustomersFilter />
            </div>
        </div>
    );
};

export default CustomersListToolBar;
